import { combineReducers } from '@reduxjs/toolkit';
import data from './dataSlice';
import state from './stateSlice';

// Export a reducer to be mounted under `liveSupport` in the root reducer
const reducer = combineReducers({
    data,
    state,
});

export default reducer;
